import { APP_VERSION } from '../version';

export const environment = {
    api: 'https://beta.budgetfacile.com',
    frontendUrl: 'https://beta-app.budgetfacile.com',
    version: APP_VERSION
};
